import * as types from './actionTypes';

// ─────────────────────────────
// FETCH MODULES
// ─────────────────────────────
export const fetchModulesRequest = (params = {}) => ({
  type: types.FETCH_MODULES_REQUEST,
  payload: params,
});

export const fetchModulesSuccess = (data) => ({
  type: types.FETCH_MODULES_SUCCESS,
  payload: data,
});

export const fetchModulesFailure = (error) => ({
  type: types.FETCH_MODULES_FAILURE,
  payload: error,
});

// ─────────────────────────────
// ADD MODULE
// ─────────────────────────────
export const addModuleRequest = (data, callback) => ({
  type: types.ADD_MODULE_REQUEST,
  payload: { data, callback },
});

export const addModuleSuccess = (data) => ({
  type: types.ADD_MODULE_SUCCESS,
  payload:data
});

export const addModuleFailure = (error) => ({
  type: types.ADD_MODULE_FAILURE,
  payload: error,
});

// ─────────────────────────────
// UPDATE MODULE
// ─────────────────────────────
export const updateModuleRequest = (id, data, callback) => ({
  type: types.UPDATE_MODULE_REQUEST,
  payload: { id, data, callback },
});

export const updateModuleSuccess = (data) => ({
  type: types.UPDATE_MODULE_SUCCESS,
  payload:data
});

export const updateModuleFailure = (error) => ({
  type: types.UPDATE_MODULE_FAILURE,
  payload: error,
});

// ─────────────────────────────
// DELETE MODULE
// ─────────────────────────────
export const deleteModuleRequest = (id) => ({
  type: types.DELETE_MODULE_REQUEST,
  payload: id,
});

export const deleteModuleSuccess = (data) => ({
  type: types.DELETE_MODULE_SUCCESS,
  payload:data
});

export const deleteModuleFailure = (error) => ({
  type: types.DELETE_MODULE_FAILURE,
  payload: error,
});
